import { render, staticRenderFns } from "./NavigationSpeed.vue?vue&type=template&id=10763c63&"
import script from "./NavigationSpeed.vue?vue&type=script&lang=js&"
export * from "./NavigationSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports